import ActionsMenu from "../../../../components/action-buttons/ActionsMenu";
import {Empty} from "antd";
import {
  EnvironmentOutlined,
  GlobalOutlined,
  LinkOutlined,
  MailOutlined,
  PhoneOutlined
} from "@ant-design/icons";
import "./style.less";
import {ContactItem, ContactListProps} from "../../../../types/contacts";
import {FC, ReactNode} from "react";
import {CONTACT_ITEM_TYPES} from "../../../../enums/contactItemTypes";
import {useAuth} from "../../../../context/authContext";

const ContactsList: FC<ContactListProps> = ({contactsController}) => {
  const {canManageContent} = useAuth();
  const {contactsList, editButtonHandler, confirmDelete} = contactsController;

  const getContactIcon = (type: ContactItem["type"]): ReactNode => {
    if (type === CONTACT_ITEM_TYPES.PHONE) return <PhoneOutlined/>;
    if (type === CONTACT_ITEM_TYPES.EMAIL) return <MailOutlined/>;
    if (type === CONTACT_ITEM_TYPES.LINK) return <GlobalOutlined/>;
    return <EnvironmentOutlined/>;
  };

  const renderValue = (item: ContactItem) => {
    if (item.type === CONTACT_ITEM_TYPES.PHONE) {
      return <a href={`tel:${item.value}`}>{item.value}</a>;
    }
    if (item.type === CONTACT_ITEM_TYPES.EMAIL) {
      return <a href={`mailto:${item.value}`}>{item.value}</a>;
    }
    if (item.type === CONTACT_ITEM_TYPES.LINK) {
      return <a href={item.value} target="_blank" rel="noreferrer">{item.value} <LinkOutlined/></a>;
    }
    return <span>{item.value}</span>;
  };

  return <div className="contacts-card">
    <div className="contacts-card__header">
      <div className="contacts-card__eyebrow">Контакти закладу</div>
      <h2>Як з нами зв’язатися</h2>
      <p>Оберіть зручний спосіб зв’язку або знайдіть потрібну адресу.</p>
    </div>

    {contactsList.length ? <div className="contacts-list">
      {contactsList.map((item) => <article className="contact-item" key={item.$id || `${item.name}-${item.value}`}>
        <div className="contact-item__icon">{getContactIcon(item.type)}</div>
        <div className="contact-item__content">
          <div className="contact-item__name">{item.name}</div>
          <div className="contact-item__value">{renderValue(item)}</div>
        </div>

        {canManageContent && <div className="contact-item__actions">
          <ActionsMenu onEdit={() => editButtonHandler(item)} onDelete={() => confirmDelete({id: item.$id || ""})}/>
        </div>}
      </article>)}
    </div> : <div className="contacts-list__empty">
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Контактів поки немає"/>
    </div>}
  </div>;
};

export default ContactsList;
